// extracted by mini-css-extract-plugin
module.exports = {"section":"videoSection_section__fdqJe","videoContainer":"videoSection_videoContainer__5giTB","videoDescription":"videoSection_videoDescription__zBsDh"};